import { render } from "./CookiePopup.vue?vue&type=template&id=75c84dea&ts=true"
import script from "./CookiePopup.vue?vue&type=script&lang=ts"
export * from "./CookiePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__